import { render, staticRenderFns } from "./VoiceMinutesService.vue?vue&type=template&id=2e3d2686&scoped=true&"
import script from "./VoiceMinutesService.vue?vue&type=script&lang=js&"
export * from "./VoiceMinutesService.vue?vue&type=script&lang=js&"
import style0 from "./VoiceMinutesService.vue?vue&type=style&index=0&id=2e3d2686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d2686",
  null
  
)

export default component.exports